import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useMediaQuery } from '../../../helpers/hooks';

interface CustomModalWindowProps {
    isOpen: boolean;
    onClose: () => void;
    leftButtonText: string;
    onLeftButtonClick: () => void;
    children: React.ReactNode;
}

const modalElement = document.getElementById('modal-window');

export const CustomModalWindow = ({
    isOpen,
    onClose,
    leftButtonText,
    onLeftButtonClick,
    children,
}: CustomModalWindowProps): JSX.Element => {
    const isMobile = useMediaQuery('(max-width: 768px)');

    useEffect(() => {
        function onEsc(e: KeyboardEvent) {
            if (e.code === 'Escape') {
                onClose();
            }
        }

        document.addEventListener('keydown', onEsc);
        return () => document.removeEventListener('keydown', onEsc);
    }, [onClose]);

    const handleBackgroundClick = (e: React.MouseEvent) => {
        if (e.target === e.currentTarget) {
            onClose();
        }
    };

    if (!isOpen) {
        return null;
    }

    return createPortal(
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 999,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
            }}
            onClick={handleBackgroundClick}
        >
            <div
                style={{
                    position: 'relative',
                    backgroundColor: 'white',
                    width: '90vw',
                    height: isMobile ? '80vh' : '90vh',
                    maxWidth: '90vw',
                    maxHeight: isMobile ? '80vh' : '90vh',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    display: 'flex',
                    flexDirection: 'column',
                }}
            >
                <button
                    style={{
                        position: 'absolute',
                        top: '20px',
                        left: '20px',
                        border: 'none',
                        backgroundColor: '#f36928',
                        color: 'white',
                        fontSize: '11px',
                        padding: '10px 10px',
                        cursor: 'pointer',
                        zIndex: 1000,
                    }}
                    onClick={onLeftButtonClick}
                >
                    {leftButtonText}
                </button>

                <button
                    style={{
                        position: 'absolute',
                        top: '10px',
                        right: '10px',
                        border: 'none',
                        background: 'transparent',
                        fontSize: '30px',
                        cursor: 'pointer',
                        zIndex: 1000,
                    }}
                    onClick={onClose}
                >
                    &times;
                </button>

                <div
                    style={{
                        padding: '70px 20px 20px 20px',
                        flexGrow: 1,
                        overflow: 'hidden',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <div
                        style={{
                            marginBottom: '20px',
                            width: '100%',
                            height: '100%',
                        }}
                    >
                        {children}
                    </div>
                </div>
            </div>
        </div>,
        modalElement!,
    );
};
